import { useEffect, useState, useCallback } from "react";
import * as manager from "../components/ThirdPartyApps/integrationGateManager";

export const useIntegrationGate = () => {
  const [modalState, setModalState] = useState(manager.getState());

  useEffect(() => {
    const unsub = manager.subscribe(s => setModalState(s));
    return () => unsub();
  }, []);

  // stable API proxy
  const requestIntegrationForTemplate = useCallback(opts => manager.requestIntegrationForTemplate(opts), []);

  const closeModal = useCallback(() => manager.closeModal(), []);
  const openModal = useCallback(opts => manager.openModal(opts), []);

  return {
    modalState,
    requestIntegrationForTemplate,
    closeModal,
    openModal,
  };
};

export default useIntegrationGate;
